import React from 'react';
import Grid from '@amzn/awsui-components-react/polaris/grid';
import Link from '@amzn/awsui-components-react/polaris/link';
import Button from '@amzn/awsui-components-react/polaris/button';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';

import { AmazonLogo } from '../images/amazonLogo';
import { externalLinks } from '../data/externalLinks';
import { useLocalizedText } from '../hooks/localizedText';

function SupportLink({ type }: { type: 'aciWiki' | 'vcWiki' | 'feature' }) {
  const { t } = useLocalizedText(['translation']);

  return (
    <Link
      href={externalLinks.support[type]}
      target="_blank"
      rel="noreferrer"
      data-aci-analytics-name={'footer_' + type}
    >
      {t(`footer.${type}`)}
    </Link>
  );
}

export function BottomNav() {
  const { t } = useLocalizedText(['translation']);

  return (
    <footer>
      <Grid
        gridDefinition={[
          { colspan: { default: 12, xl: 2, l: 2, m: 2, s: 4, xs: 4, xxs: 6 } },
          { colspan: { default: 12, xl: 5, l: 5, m: 5, s: 4, xs: 4, xxs: 6 } },
          { colspan: { default: 12, xl: 5, l: 5, m: 5, s: 4, xs: 4, xxs: 6 } },
        ]}
      >
        <AmazonLogo />
        <div className="links">
          <SpaceBetween direction="vertical" size="s">
            <SupportLink type="aciWiki" />
            <SupportLink type="vcWiki" />
            <SupportLink type="feature" />
          </SpaceBetween>
        </div>
        <SpaceBetween size="l">
          <h4>{t('footer.follow.title')}</h4>
          <span className="copy">{t('footer.follow.copy')}</span>
          {/*
            This footer link intentionally ships to all users (not gated behind NavigationRedesign):
            it points everyone at the VC interest list, which the new nav also links to. The analytics
            name was renamed footer_a2zLink -> footer_newsletter to match; this is a deliberate break
            in that link's dashboard history (accepted — low-risk footer link, not a critical metric).
          */}
          <Button
            iconName="external"
            href={externalLinks.sideNav.newsletter}
            iconAlign="right"
            target="_blank"
            fullWidth
            data-aci-analytics-name={'footer_newsletter'}
            variant="primary"
          >
            {t('footer.follow.button')}
          </Button>
        </SpaceBetween>
      </Grid>
    </footer>
  );
}
